namespace RioERP.Masters {
    export interface DtdcApiDetailsForm {
        AccessToken: Serenity.StringEditor;
        Cookie: Serenity.StringEditor;
        CustomerCode: Serenity.StringEditor;
        ServiceTypeId: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Address1: Serenity.StringEditor;
        Address2: Serenity.StringEditor;
        City: Serenity.StringEditor;
        State: Serenity.StringEditor;
        Pincode: Serenity.StringEditor;
        Phone: Serenity.StringEditor;
        ApiKey: Serenity.StringEditor;
    }

    export class DtdcApiDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.DtdcApiDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!DtdcApiDetailsForm.init)  {
                DtdcApiDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(DtdcApiDetailsForm, [
                    'AccessToken', w0,
                    'Cookie', w0,
                    'CustomerCode', w0,
                    'ServiceTypeId', w0,
                    'Name', w0,
                    'Address1', w0,
                    'Address2', w0,
                    'City', w0,
                    'State', w0,
                    'Pincode', w0,
                    'Phone', w0,
                    'ApiKey', w0
                ]);
            }
        }
    }
}
